import React from "react";
import { connect } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { IAppState } from "redux/reducers";
import { ConfirmDialog } from "components/shared-ui/dialogs/common/confirm-dialog/confirm-dialog";
import styles from "./delete-confirmation.module.scss";
import { iamCredentialsActions } from "redux/actions/iam-credentials";
import { IIAMCredentialUpdateRequest } from "api/entities/iam-credentials";

const mapDispatchToProps = (
  dispatch: ThunkDispatch<IAppState, void, Action>
) => {
  return {
    closeDeleteConfirmation: () => {
      dispatch(iamCredentialsActions.deleteConfirmation.close());
    },
  };
};

const mapStateToProps = (state: IAppState) => ({
  isOpen: state.accessCredentials.deleteConfirmation.isOpen,
  data: state.accessCredentials.deleteConfirmation.data,
});

export interface IDeleteConfirmationProps
  extends ReturnType<typeof mapDispatchToProps>,
    ReturnType<typeof mapStateToProps> {
  onDelete: (request: IIAMCredentialUpdateRequest) => void;
}

export const DeleteConfirmation = connect(
  mapStateToProps,
  mapDispatchToProps
)((props: IDeleteConfirmationProps) => {
  function handleConfirm() {
    props.onDelete({
      AccessKeyId: props.data.AccessKeyId,
      UserName: props.data.UserName,
      Status: props.data.Status,
    });
    props.closeDeleteConfirmation();
  }

  return (
    <ConfirmDialog
      testId="delete-application-credentials-confirmation"
      title="Delete Access Credentials"
      confirmText="Confirm"
      open={props.isOpen}
      onClose={props.closeDeleteConfirmation}
      onConfirm={handleConfirm}
    >
      <div className={styles.content}>
        Are you sure you want to delete <strong>{props.data?.AccessKeyId}</strong>{" "}
        credential from Myota? All data will be lost.
      </div>
    </ConfirmDialog>
  );
});
